<template>
  <div>
    <Alert type="error" v-if="errorMsgShow" show-icon>获取安全组规则数据失败</Alert>
    <Table
      v-else
      :loading="tableLoading"
      ref="table"
      :data="data"
      :height="data.length > 7 ? 300 : 0"
      :columns="columns">
    </Table>
  </div>
</template>

<script>
import { getPrivateCloudAllSecurityGroupRule } from '@/api/private-cloud/security-group-rule'
export default {
  name: 'security-group-rule-list',
  props: {
    security_group_id: String,
    required: true
  },
  data () {
    return {
      data: [],
      columns: [
        {
          title: '方向',
          align: 'center',
          minWidth: 80,
          tooltip: true,
          key: 'direction',
          render: (h, params) => {
            let result = ''
            if (params.row.direction === 'ingress') {
              result = '入口'
            } else if (params.row.direction === 'egress') {
              result = '出口'
            }
            return h('span', result)
          }
        },
        {
          title: '以太网类型',
          align: 'center',
          minWidth: 90,
          tooltip: true,
          key: 'ethertype'
        },
        {
          title: 'IP协议',
          align: 'center',
          minWidth: 80,
          tooltip: true,
          key: 'protocol',
          render: (h, params) => {
            let result = params.row.protocol
            if (!params.row.protocol) {
              result = '任何'
            }
            return h('span', result)
          }
        },
        {
          title: '端口范围',
          align: 'center',
          minWidth: 100,
          tooltip: true,
          render: (h, params) => {
            let result = '任何'
            if (params.row.port_range_min && params.row.port_range_max) {
              if (params.row.port_range_min === params.row.port_range_max) {
                result = params.row.port_range_max
              } else {
                result = params.row.port_range_min + ' - ' + params.row.port_range_max
              }
            }
            return h('span', result)
          }
        },
        {
          title: '远程IP',
          align: 'center',
          minWidth: 120,
          tooltip: true,
          key: 'remote_ip_prefix',
          render: (h, params) => {
            let result = params.row.remote_ip_prefix
            if (!params.row.protocol && !params.row.remote_ip_prefix && !params.row.remote_ip_prefix) {
              if (params.row.ethertype === 'IPv4') {
                result = '0.0.0.0/0'
              } else if (params.row.ethertype === 'IPv6') {
                result = '::/0'
              }
            }
            return h('span', result)
          }
        },
        {
          title: '远程安全组',
          align: 'center',
          minWidth: 120,
          tooltip: true,
          key: 'remote_group_name',
          render: (h, params) => {
            let result = params.row.remote_group_id
            if (params.row.remote_group_id === this.security_group_id) {
              result += ' (当前)'
            }
            return h('span', result)
          }
        }
      ],
      errorMsgShow: false
    }
  },
  created: function () {
    this.getTableData()
  },
  methods: {
    getTableData () {
      this.tableLoading = true
      getPrivateCloudAllSecurityGroupRule({ security_group_id: this.security_group_id }).then(res => {
        this.data = res.data
        this.errorMsgShow = false
        this.tableLoading = false
      }).catch(res => {
        this.errorMsgShow = true
        this.tableLoading = false
      })
    }
  }
}
</script>

<style scoped>

</style>
